const translations = {
    'log.farmersNoTools': 'Farmers without tools: %d',
    'log.huntersNoTools': 'Hunters without tools: %d',
    'log.none': 'No warnings.',
    'log.section': 'Warnings',
};

export default translations;
